import React, {FC} from "react";

export interface SingleContentDemoProps {
  content: any;
}
const SingleContentDemo: FC<SingleContentDemoProps> = ({ content }) => {
  return ( <p style={{whiteSpace: "pre-line"}}>{content} </p> );
};

export default SingleContentDemo;
